import { useNavigate } from 'react-router-dom'
import { Home, ArrowLeft, Lock } from 'lucide-react'

export function ForbiddenPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 via-white to-orange-50 px-4">
      <div className="text-center max-w-2xl mx-auto">
        <div className="mb-8 relative">
          <div className="text-[180px] md:text-[220px] font-bold text-amber-200 leading-none select-none">
            403
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-6xl md:text-8xl">🔒</div>
          </div>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          访问被拒绝
        </h1>

        <p className="text-lg text-gray-600 mb-8 leading-relaxed">
          很抱歉，您没有权限访问此页面。<br />
          请登录您的账户或联系管理员获取访问权限。
        </p>

        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-8 max-w-md mx-auto">
          <div className="flex items-start gap-3">
            <Lock className="text-amber-500 flex-shrink-0 mt-0.5" size={20} />
            <div className="text-left">
              <p className="text-sm font-medium text-amber-800 mb-1">错误代码：403</p>
              <p className="text-sm text-amber-700">
                禁止访问 - 您没有足够的权限
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-white font-medium rounded-lg transition-all duration-300 hover:bg-primary-600 hover:shadow-lg hover:shadow-primary-500/25 active:scale-95"
          >
            <Home size={20} />
            返回首页
          </button>

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-white text-primary-500 font-medium rounded-lg border-2 border-primary-500 transition-all duration-300 hover:bg-primary-50 active:scale-95"
          >
            <ArrowLeft size={20} />
            返回上一页
          </button>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            需要帮助？请联系
            <a href="/cooperation" className="text-primary-500 hover:text-primary-600 mx-1">
              客服支持
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
